const games = {
    'houses': {
        1: {
            image: 'level-1.png',
            targets: [
                {
                    icon: 'check',
                    bottom: 250,
                    left: 1120,
                    popUpBottom: 520,
                    popUpLeft: 800,
                    points: 10,
                    name: 'orion-camera',
                    info: {
                        origin: 'bottom-right',
                        label: 'External Camera',
                        content: 'Home intrusion can take place even without physically entering a home, such as hooking keys through a letter box. An Orion Camera placed inside the customer’s home can detect unusual motion and also takes images of any intruders.',
                    },
                },
                {
                    icon: 'check',
                    bottom: 90,
                    left: 620,
                    popUpBottom: 450,
                    popUpLeft: 250,
                    points: 10,
                    name: 'smart-door-bell',
                    info: {
                        origin: 'top-right',
                        label: 'Smart Door Bell',
                        content: 'Never miss a delivery or anyone for that matter! A smart doorbell doubles as an extra camera so customers can see, hear and speak to visitors to their home from anywhere in the world using their mobile device.',
                    },
                },
            ],
        },
        2: {
            image: 'level-2.png',
            targets: [
                {
                    icon: 'check',
                    bottom: 330,
                    left: 370,
                    popUpBottom: 630,
                    popUpLeft: 200,
                    points: 10,
                    name: 'smart-external-cameras',
                    info: {
                        origin: 'bottom-left',
                        label: 'Smart external cameras',
                        content: 'For keeping an eye on things outside your property, smart external cameras constantly monitor. If any motion is detected the customer will be notified via their mobile device.',
                    },
                },
                {
                    icon: 'check',
                    bottom: 320,
                    left: 770,
                    popUpBottom: 280,
                    popUpLeft: 850,
                    points: 10,
                    name: 'smart-smoke-detectors',
                    info: {
                        origin: 'bottom-left',
                        label: 'Smart smoke detectors',
                        content: 'Alarms alone are only useful if someone can hear them ring. Smart smoke detectors quicky identify if there’s a fire and can quickly notify and respond if an issue arises, even if you are not at home. 24/7 monitoring offers around the clock detection.',
                    },
                },
            ],
        },
    },
    'flats': {
        1: {
            image: 'flat-level-1.png',
            targets: [
                {
                    icon: 'check',
                    bottom: 200,
                    left: 870,
                    popUpBottom: 540,
                    popUpLeft: 700,
                    points: 10,
                    name: 'ext-cameras-shock-sensors',
                    info: {
                        origin: 'top-right',
                        label: 'External cameras & shock sensors',
                        content: (
                            <>
                                Avoid leaving valuables or items of expense on show.<br />
                                Our external cameras can capture a movement from outside and coupled with our shock sensors can alert you to anyone who is considering to try their luck.
                            </>
                        ),
                    },
                },
                {
                    icon: 'check',
                    bottom: 280,
                    left: 480,
                    popUpBottom: 220,
                    popUpLeft: 240,
                    points: 10,
                    name: 'smart-home-security-hub',
                    info: {
                        origin: 'top-right',
                        label: 'Smart Home Security Hub',
                        content: 'Making it obvious that you are taking a holiday or prolonged absence is just one more invitation to burglars. Smart Home Security Hub links it all together. Powered by WiFi and backed up by our award-winning EE 4G mobile network.',
                    },
                },
            ],
        },
        2: {
            image: 'flat-level-2.png',
            targets: [
                {
                    icon: 'check',
                    bottom: 200,
                    left: 610,
                    popUpBottom: 480,
                    popUpLeft: 295,
                    points: 10,
                    name: 'control-pad',
                    info: {
                        origin: 'top-right',
                        label: 'Control Pad',
                        content: 'If any intruder were to enter your property, our easy to use Control Pad can omit a whopping 105 Decibel siren, which is louder than a jet flying over at 100ft!',
                    },
                },
                {
                    icon: 'check',
                    bottom: 380,
                    left: 870,
                    popUpBottom: 280,
                    popUpLeft: 810,
                    points: 10,
                    name: 'shock-sensors',
                    info: {
                        origin: 'top-right',
                        label: 'Shock sensors',
                        content: 'Motion detectors and cameras are one way to deter unwanted guests but shock sensors  will let customers know if any entry point has been forced open, broken, or even shaken.',
                    },
                },
            ],
        },
    },
};

export {
    games,
};
